
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.487 3.538c-4.39 0-7.949 3.556-7.949 7.94 0 4.383 3.558 7.938 7.95 7.938 2.19 0 4.172-.884 5.61-2.316a7.906 7.906 0 002.338-5.623c0-4.383-3.558-7.939-7.949-7.939zM2 11.478C2 6.241 6.248 2 11.487 2s9.487 4.242 9.487 9.477a9.436 9.436 0 01-2.266 6.147l3.066 3.063a.77.77 0 01-1.087 1.088l-3.069-3.065a9.458 9.458 0 01-6.13 2.244C6.247 20.954 2 16.712 2 11.477z","fill":"#F2F3F5"}}),_c('path',{attrs:{"d":"M11.5 7.5v8M15.5 11.5h-8","stroke":"#F2F3F5","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    